import React, { useState, useEffect } from "react";
import axios from 'axios';
import Tables from '../common/Table/Table';
import { get_tv_schedule } from "../../config/apiUrls"

function TVWeeklyScheduleTable(props) {
    const { network, contentTypes, year, week, zeroContentTypes, setZeroContentTypes } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const contentTypeIds = contentTypes.map(el => el.contentTypeId);
        axios.get(`${get_tv_schedule}/${network.networkId}/${year.year}/${week.weekId}/${contentTypeIds.toString()}`)
            .then((response) => {
                setData(response.data);
                // let temp = { ... }
                let arr = response ?.data.filter(ele => {
                    let temp = { ...ele };
                    delete temp.charsAvailable
                    delete temp.contentType
                    delete temp.contentTypeDisplayName
                    var sum = Object.values(temp).reduce(function (a, b) {
                        return a + b;
                    }, 0);
                    return sum === 0
                }).map(e => e.contentType);
                zeroContentTypes[network.network] = arr
                setZeroContentTypes(zeroContentTypes);
                setLoading(false)
            }).catch(error => {
                setLoading(false);
            })
    }, [network]);
    return (
        <Tables loading={loading} data={data} {...props} />
    )
}

export default TVWeeklyScheduleTable